export const starsTitles = {
    1: 'feedbacks.starsTitles.1',
    2: 'feedbacks.starsTitles.2',
    3: 'feedbacks.starsTitles.3',
    4: 'feedbacks.starsTitles.4',
    5: 'feedbacks.starsTitles.5'
};

export const starsPlaceholders = {
    1: 'feedbacks.starsPlaceholders.1',
    2: 'feedbacks.starsPlaceholders.2',
    3: 'feedbacks.starsPlaceholders.3',
    4: 'feedbacks.starsPlaceholders.4',
    5: 'feedbacks.starsPlaceholders.5'
};
